"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M5.7743 14.3755a3.5502 3.5502 0 0 0-1.2982 4.8502 3.5505 3.5505 0 0 0 4.8502 1.2982l7.6636-4.4251-7.1013-4.0994-4.1143 2.3761z",
    fill: "url(#a)"
  }), _react.default.createElement("path", {
    style: "mixBlendMode:multiply",
    d: "m16.9871 16.0988-7.0985-4.0994-1.2367.715 8.3352 3.3844z",
    fill: "url(#b)"
  }), _react.default.createElement("path", {
    d: "m16.9873 7.9013-7.6608-4.425a3.5498 3.5498 0 0 0-3.552 6.147l4.1142 2.3761 7.0986 4.098c3.1519-1.8206 3.1519-6.3741 0-8.196z",
    fill: "url(#c)"
  }), _react.default.createElement("defs", null, _react.default.createElement("linearGradient", {
    id: "a",
    x1: "3.9078",
    y1: "16.5002",
    x2: "17.0304",
    y2: "16.5002",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#00D2FF"
  }), _react.default.createElement("stop", {
    offset: "1",
    stopColor: "#0AF"
  })), _react.default.createElement("linearGradient", {
    id: "b",
    x1: "4970.47",
    y1: "289.199",
    x2: "5396.43",
    y2: "586.524",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#00D2FF"
  }), _react.default.createElement("stop", {
    offset: "1",
    stopColor: "#0AF"
  })), _react.default.createElement("linearGradient", {
    id: "c",
    x1: "8701.44",
    y1: "637.569",
    x2: "10439.4",
    y2: "637.569",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#FF4B7D"
  }), _react.default.createElement("stop", {
    offset: "1",
    stopColor: "#FF2D64"
  })))];
};

exports.default = _default;